var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/require-default-props */
import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import { string, node } from 'prop-types';
import Heading from '../heading/Heading';
import Icons from '../icons/collection';
var PlusIcon = Icons.Plus;
var MinusIcon = Icons.Minus;
var OutShareIcon = Icons.OutShare;
var AccordionWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: repeat(12,1fr);\n  background-color: #FFFFFF;\n  border-radius: 5px;\n  border-bottom: 1px solid #cfd8dc;\n  border-top: 1px solid #cfd8dc;\n  border-right: 1px solid #cfd8dc;\n  border-left: 1px solid #cfd8dc;\n  box-sizing: border-box;\n"])));
AccordionWrapper.displayName = 'AccordionWrapper';
var AccordionToggle = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 10fr 1fr;\n  grid-auto-rows: auto;\n  grid-column-start: 1;\n  grid-column-end: 13;\n  cursor: pointer;\n  padding-left: 20px;\n"])));
AccordionToggle.displayName = 'AccordionToggle';
var AccordionCollapse = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 67px 10fr 1fr;\n  grid-auto-rows: auto;\n  grid-column-start: 1;\n  grid-column-end: 13;\n  cursor: pointer;\n  padding-left: 20px;\n  overflow: hidden;\n  min-height: 0;\n  transition: max-height 0.1s ease;\n"])));
AccordionCollapse.displayName = 'AccordionCollapse';
var AccordionTitle = styled(Heading)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  grid-column-start: 2;\n  grid-column-end: 3;\n  grid-row-start: 1;\n  font-family: Montserrat;\n  font-size: 22px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.36;\n  letter-spacing: normal;\n  padding-left: 0;\n  padding-top: 8px;\n  pointer-events: none;\n"])), function (props) {
  return props.color;
});
AccordionTitle.displayName = 'AccordionTitle';
var AccordionSubtitle = styled.p(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  grid-column-start: 2;\n  grid-column-end: 3;\n  font-family: Montserrat;\n  font-size: 16px;\n  font-weight: 600;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 28px;\n  letter-spacing: normal;\n  color: #42484d;\n  margin-bottom: 0;\n  margin-top: -18px;\n  padding-left: 0;\n  padding-top: 0;\n  pointer-events: none;\n"])));
AccordionSubtitle.displayName = 'AccordionSubtitle';
var AccordionDescription = styled.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  grid-column-start: 2;\n  grid-column-end: 3;\n  font-size: 16px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 28px;\n  letter-spacing: normal;\n  color: #707070;\n  padding-left: 0;\n  padding-right: 12px;\n  margin-top: 2px;\n  pointer-events: none;\n  "])));
AccordionDescription.displayName = 'AccordionDescription';
var StyledPlusIcon = styled(PlusIcon)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  grid-column-start: 3;\n  grid-row-start: 1;\n  width: ", ";\n  height: ", ";\n  background-color: #ffffff;\n  margin-top: 40px;\n  background-repeat: no-repeat;\n  justify-self: right;\n  margin-right: 20px;\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
StyledPlusIcon.displayName = 'AccordionPlusIcon';
var StyledMinusIcon = styled(MinusIcon)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  grid-column-start: 3;\n  grid-row-start: 1;\n  width: ", ";\n  height: ", ";\n  background-color: #ffffff;\n  margin-top: 40px;\n  background-repeat: no-repeat;\n  justify-self: right;\n  margin-right: 20px;\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
StyledMinusIcon.displayName = 'AccordionMinusIcon';
var StyledOutShareIcon = styled(OutShareIcon)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  grid-column-start: 3;\n  background-color: #ffffff;\n  margin: auto auto;\n  margin-right: -4px;\n  background-repeat: no-repeat;\n"])));
StyledOutShareIcon.displayName = 'AccordionShareIcon';
var StyledAccordionListGroup = styled.ul(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 10fr 1fr;\n  grid-template-rows: auto;\n  grid-column-start: 1;\n  grid-column-end: 13;\n  background-color: #ffffff;\n  border-top: 1px solid #cfd8dc;\n  list-style-type: none;\n  padding-left: 0;\n  margin-right: 20px;\n\n  &:first-child {\n    border-top-width: 0;\n  }\n  &:last-child  {\n    border-bottom-width: 0;}\n"])));
StyledAccordionListGroup.displayName = 'StyledAccordionListGroup';
var StyledAccordionListItem = styled.a(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 10fr 1fr;\n  grid-auto-rows: auto;\n  font-weight: 600;\n  align-items: center;\n  grid-column-start: 1;\n  grid-column-end: 13;\n  border-top: 1px solid #cfd8dc;\n  background-color: #ffffff;\n  text-decoration: none;\n  color: #3380A7;\n"])));
StyledAccordionListItem.displayName = 'StyledAccordionListItem';
var StyledAccordionListItemText = styled.p(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  grid-column-start: 2;\n  color: #3380A7;\n"])));
StyledAccordionListItemText.displayName = 'StyledAccordionListItemText';

function Accordion(_ref) {
  var title = _ref.title,
      description = _ref.description,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      iconName = _ref.iconName,
      children = _ref.children,
      _ref$subtitle = _ref.subtitle,
      subtitle = _ref$subtitle === void 0 ? null : _ref$subtitle,
      _ref$dataAnalyticsLab = _ref.dataAnalyticsLabel,
      dataAnalyticsLabel = _ref$dataAnalyticsLab === void 0 ? null : _ref$dataAnalyticsLab,
      restProps = _objectWithoutProperties(_ref, ["title", "description", "className", "iconName", "children", "subtitle", "dataAnalyticsLabel"]);

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      isCollapsed = _useState2[0],
      setCollapsed = _useState2[1];

  var _useState3 = useState('0px'),
      _useState4 = _slicedToArray(_useState3, 2),
      setHeight = _useState4[0],
      setHeightState = _useState4[1];

  var _useState5 = useState('plusLink'),
      _useState6 = _slicedToArray(_useState5, 2),
      setRotate = _useState6[0],
      setRotateState = _useState6[1];

  var _useState7 = useState('plus icon'),
      _useState8 = _slicedToArray(_useState7, 2),
      setAlt = _useState8[0],
      setAltState = _useState8[1];

  var hasSubtitle = subtitle !== null;
  var content = useRef(null);
  var HeadingIcon = Icons[iconName]; // adds icon to Accordion children and places children in their own row on grid

  var newChildren = [];
  React.Children.map(children, function (child, i) {
    newChildren.push( /*#__PURE__*/React.createElement(StyledAccordionListItem, {
      href: child.props.href,
      key: "".concat(i + 1, "-text"),
      className: cn(className, 'accordion-list-item'),
      "data-analytics-label": dataAnalyticsLabel,
      "data-analytics-id": child.props.dataAnalyticsId
    }, /*#__PURE__*/React.createElement(StyledAccordionListItemText, {
      "data-analytics-label": dataAnalyticsLabel,
      className: cn(className, 'accordion-link-text')
    }, child.props.children), /*#__PURE__*/React.createElement(StyledOutShareIcon, {
      className: cn(className, 'accordion-share-icon'),
      name: "outShare",
      fill: "#3380a7",
      width: "24px",
      height: "14px",
      key: "".concat(i + 1, "-icon"),
      "data-analytics-label": dataAnalyticsLabel
    })));
  });

  function toggleAccordion() {
    setHeightState(isCollapsed === 'collapseContent' ? '0px' : "".concat(content.current.scrollHeight, "px"));
    setRotateState(isCollapsed === 'collapseContent' ? 'plusLink' : 'minusLink');
    setAltState(isCollapsed === 'collapseContent' ? 'plus icon' : 'minus icon');
    setCollapsed(isCollapsed === '' ? 'collapseContent' : '');
  }

  return /*#__PURE__*/React.createElement(AccordionWrapper, _extends({
    "data-analytics-label": dataAnalyticsLabel,
    "data-test-id": "scl-sharp-accordion",
    className: cn(className, 'accordion-wrapper')
  }, restProps), /*#__PURE__*/React.createElement(AccordionToggle, {
    onClick: toggleAccordion,
    "data-analytics-label": dataAnalyticsLabel,
    "data-analytics-id": "sharp-accordion-toggle",
    "data-test-id": "accordion-toggle",
    className: cn(className, 'accordion-toggle')
  }, /*#__PURE__*/React.createElement(HeadingIcon, {
    height: "50px",
    width: "50px",
    viewBox: "0 0 51 51",
    "data-test-id": "accordion-heading-icon",
    className: cn(className, 'accordion-heading-icon'),
    "data-analytics-label": dataAnalyticsLabel,
    style: {
      backgroundColor: '#ffffff',
      marginTop: '30px',
      marginRight: '16px',
      backgroundRepeat: 'no-repeat',
      fill: '#6599b3'
    }
  }), /*#__PURE__*/React.createElement(AccordionTitle, {
    variant: 3,
    color: "#3380A7",
    "data-test-id": "accordion-heading",
    className: cn(className, 'accordion-title'),
    "data-analytics-label": dataAnalyticsLabel
  }, title), hasSubtitle && /*#__PURE__*/React.createElement(AccordionSubtitle, {
    "data-test-id": "accordion-subtitle",
    className: cn(className, 'accordion-subtitle'),
    "data-analytics-label": dataAnalyticsLabel
  }, subtitle), isCollapsed === '' ? /*#__PURE__*/React.createElement(StyledPlusIcon, {
    name: "plus",
    role: "button",
    className: cn("accordion ".concat(isCollapsed), className, 'accordion-plus-icon'),
    fill: "#3380a7",
    width: "16px",
    height: "18px",
    "data-test-id": "accordion-plus-icon",
    "data-analytics-label": dataAnalyticsLabel
  }) : /*#__PURE__*/React.createElement(StyledMinusIcon, {
    role: "button",
    className: cn("accordion ".concat(isCollapsed), className, 'accordion-minus-icon'),
    fill: "#3380a7",
    width: "16px",
    height: "18px",
    "data-test-id": "accordion-minus-icon",
    "data-analytics-label": dataAnalyticsLabel
  }), /*#__PURE__*/React.createElement(AccordionDescription, {
    className: cn(className, 'accordion-description'),
    "data-analytics-label": dataAnalyticsLabel
  }, description)), /*#__PURE__*/React.createElement(AccordionCollapse, {
    role: "region",
    id: "collapsible-content",
    "aria-labelledby": "accordion-toggle-button",
    className: cn(className, 'accordion-collapse-section'),
    ref: content,
    style: {
      maxHeight: "".concat(setHeight)
    },
    "data-test-id": "accordion-collapse",
    "data-analytics-label": dataAnalyticsLabel
  }, /*#__PURE__*/React.createElement(StyledAccordionListGroup, {
    className: cn(className, 'accordion-list-group'),
    "data-analytics-label": dataAnalyticsLabel
  }, newChildren)));
}

Accordion.Item = StyledAccordionListItem;
Accordion.Item.displayName = 'Accordion.Item';
Accordion.propTypes = {
  /**
   Required text to use as the title of the Accordion.
  */
  title: string.isRequired,

  /**
   Required text used to describe purpose of Accordion.
  */
  description: string.isRequired,

  /**
   Optional className to include in rendered component
  */
  className: string,

  /**
   Required name of icon you wish to render. Look at Icon component for a list of names.
  */
  iconName: string.isRequired,

  /**
   Required and consists of everything between opening and closing tags of Accordion
  */
  children: node.isRequired,

  /**
   Optional text to appear as a subtitle.
  */
  subtitle: string,

  /**
   Optional id for analytics tracking.
  */
  dataAnalyticsLabel: string
};
export default Accordion;